import { Badge, Button, TOUCH } from "@nymbl/nos2-rules";
import { Award, ClipboardCheck, Palmtree } from "lucide-react";
import { INCENTIVES_URL } from "@/lib/team/constants";

interface TeamActionsProps {
  overdueCount: number;
  onSignOffs: () => void;
  onPto: () => void;
}

/**
 * My Team's primary actions, shown in the page header. On phones they take the shell's second row.
 */
export function TeamActions({ overdueCount, onSignOffs, onPto }: TeamActionsProps) {
  return (
    <>
      <Button
        variant="outline"
        className={TOUCH}
        aria-label={overdueCount > 0 ? `Time sign-offs, ${overdueCount} overdue` : "Time sign-offs"}
        onClick={onSignOffs}
      >
        <ClipboardCheck aria-hidden="true" />
        Time sign-offs
        {overdueCount > 0 && <Badge variant="destructive">{overdueCount}</Badge>}
      </Button>
      <Button variant="outline" className={TOUCH} onClick={onPto}>
        <Palmtree aria-hidden="true" />
        PTO requests
      </Button>
      {INCENTIVES_URL && (
        <Button asChild variant="outline" className={TOUCH}>
          <a href={INCENTIVES_URL} target="_blank" rel="noreferrer">
            <Award aria-hidden="true" />
            Incentives
          </a>
        </Button>
      )}
    </>
  );
}
